import { Box, Button } from "@mui/material";
import { styles } from "./styles";
import backGroundMobile from "./appBackgroundMob.jpg";
import backGround from "./appBackground.jpg";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const WelcomePage: React.FC = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    document.title = "Welcome - OmMuse";
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window && window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imgSrc = windowWidth >= 800 ? backGround : backGroundMobile;
  const margin = windowWidth >= 800 ? "100px" : "60px";

  return (
    <Box
      sx={[
        styles.container,
        {
          marginTop: "30px",
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(255,255,255,0.05)), url(${imgSrc})`,
        },
      ]}
    >
      <Box sx={[styles.headerContainer, { marginLeft: margin }]}>
        <h1 style={styles.firstHeading}>Welcome to OmMuse</h1>
      </Box>
      {!isAuthenticated && (
        <Box sx={styles.buttonContainer}>
          <Button
            variant="contained"
            sx={[styles.buttonStyle, { marginTop: "20px", marginLeft: margin }]}
            onClick={() => {
              localStorage.clear();
              loginWithRedirect({
                appState: { targetUrl: "/" },
              });
            }}
          >
            Log in | Sign up
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default WelcomePage;
